
<template>
  <div class="ob-main tilt-main">
    <div class="dark-overlay" :style="{'justify-content': $screen.breakpoint !== 'sm' ? 'center' : 'flex-end'}" v-if="!login">
      <div class="land-quarter" style="flex-direction:column;">
        <img :src="logoUrl" />
        <h5 v-if="$screen.breakpoint !== 'sm' || $store.state.lang !== 'en'">{{clauses.tagline}}</h5>
        <h6 v-else style="font-size:.9em;margin-top:8px;">{{clauses.tagline}}</h6>
      </div>
      <div
        class="land-quarter btn-quarter"
        :style="{
          'flex-direction': $screen.breakpoint !== 'sm' ? 'row' : 'column',
          'margin-bottom': $screen.breakpoint !== 'sm' ? '0px' : computedCookieSpacing
          }"
        v-if="!moreInfo"
        >
          <a class="land-btn prim-btn" @click="login = true;">{{clauses.login}}</a>
          <a class="land-btn sec-btn" @click="requestAccess" :style="{'font-size': $store.state.lang === 'jp' ? '.85em' : '1em'}">{{clauses.req}}</a>
          <a class="land-btn tre-btn" @click="moreInfo = true">{{clauses.more}}</a>
      </div>
      <div
        class="land-quarter btn-quarter"
        :style="{
          'flex-direction': $screen.breakpoint !== 'sm' ? 'row' : 'column',
          'margin-bottom': $screen.breakpoint !== 'sm' ? '0px' : computedCookieSpacing
        }"
        v-if="moreInfo"
      >
        <a class="land-btn tre-btn" @click="$router.push({path: '/api'});">API Docs</a>
        <a class="land-btn sec-btn" @click="toWebsite">Website</a>
        <a class="land-btn alert-btn" @click="moreInfo = false">Back</a>
      </div>
      <h3 class="splash-lang" @mouseover="initHover" @mouseleave="$store.dispatch('destroyHover')" @click="$store.dispatch('setLang')">{{$store.state.lang === 'en' ? '日本語' : 'English'}}</h3>
    </div>
    <div class="dark-overlay" v-else>
      <login-component v-on:closeLogin="login = false"></login-component>
    </div>
  </div>
</template>

<script>

  import Login from './Login';
  import Lang from '@/lib/langTemplates/LandingTemplate';

  export default {

    data(){
      return {
        logoUrl: 'https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/pro-box.png',
        login: false,
        moreInfo: false
      }
    },

    components: {
      'login-component': Login
    },

    computed: {
      clauses(){
        let lPref = this.$store.state.lang;
        return Object.keys(Lang.clauses).reduce((a, i) => {
          a[i] = Lang.clauses[i][lPref];
          return a;
        }, {});
      },
      computedCookieSpacing(){
        return this.$store.state.cookieAccepted ? '30%': '60%';
      }
    },

    methods: {
      toWebsite(){
        window.location = 'https://www.breezi-pro.io';
      },
      requestAccess(){
        this.$store.dispatch('setObStep', 0);
        this.$store.dispatch('initOnboard', 'access');
      },
      initHover(evt){
        this.$store.dispatch(
          'setHoverTempFromComponent',
          !this.$store.state.hover.temp.title.length
          ? {
            x: evt.pageX,
            y: evt.pageY,
            type: 'mini',
            title: 'Toggle Language'
          }
          : {}
        )
      }
    },

    mounted(){
      this.$store.dispatch('clearState');
      this.$store.state.helper.settings = false;
      this.$store.dispatch('loadingOff');

    },

    watch: {

    }

  }
</script>

<style>

.land-quarter {
  width: 100%;
  margin: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-quarter {
  width: 100%;
  display: flex;
  align-self: center;
  justify-self: center;
  justify-content: center;
  align-items: center;
}

.land-quarter img {
  padding: 0px;
  margin: 0px;
  /* height: 100px; */
  width: 480px;
  max-width: 90%;
  align-self: center;
  justify-self: center;
  border-bottom: 2px solid #dce1ec;
  padding-bottom: 10px;
}

.land-quarter h5 {
  font-weight: lighter;
  margin: 4px;
  width: 100%;
  text-align: center;
  font-size: 1.2em;
}

.col-row {
  background-color: red;
  display: flex;
  justify-content: center;
  align-items: center;
}

.splash-lang {
  position: absolute;
  left: 3%;
  top: 3%;
  cursor: pointer;
}

.splash-lang:hover {
  color: rgb(0, 153, 191);
}

</style>



// WEBPACK FOOTER //
// src/components/landing/Landing.vue